<div class="d-flex justify-content-between m-2">	
	<div class="h3">{{ 'requirementReview.reviewTitle' | translate }}</div>

	<div class="actions m-10">
		<button color="primary" 
				mat-raised-button 
				[disabled]="this.isSaving()"
				(click)="close()">
		  		{{ 'requirementReview.close' | translate }}   
		</button>				
	</div>
</div>

<div class="container-fluid">
	<div class="bg-white shadow-sm p-5 m-3">

		<!-- <div class="row mb-4">
			<div class="col">
				<span class="text-uppercase">Documento: <strong
                    class="text-primary">{{ transactionRequirementService.commentReviewField }}</strong></span>
			</div>
		</div>

		<div class="row mb-2">
			<div class="col">
				<h2>Seleccione comentario</h2>
			</div>
		</div>

		<div class="row mb-4">
			<div class="col">
				<mat-form-field appearance="outline">
					<mat-select placeholder="Seleccione comentario" (selectionChange)="changeComment( $event )">
						<mat-option *ngFor="let item of comments"
									[value]="removeTags(item.Value)"
									>
							{{ removeTags(item.Value) }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div> -->
		
		<div class="row mb-2">
			<div class="col">
				<h2>{{ 'requirementReview.commentForReview' | translate }}</h2>
			</div>
		</div>

		<form [formGroup]="form">
			<!-- <div class="row">   
				<div class="col s12">         
					<mat-form-field appearance="outline">
						<mat-label>{{ 'requirementReview.commentTitle' | translate }}</mat-label>
						<textarea matInput type="text" name="number" formControlName="Comment" style="height: 100px; width: 100% !important;"></textarea>
						<mat-hint class="materialize-red-text" 
								  [hidden]="!form.controls.Comment.errors || !form.controls.Comment.touched==true ">
							{{ 'requirementReview.comment' | translate }}
						</mat-hint>				          		
					</mat-form-field>          			          	          				          		        			          	             	
				</div>      
			</div> -->
			
			<div class="row">
				<div class="col s12">
					<div id="toolbar-container">
					</div>
					<div id="editor" style="border: 1px solid #c4c4c4;" class="pb-4">
					  <ckeditor [editor]="Editor" formControlName="Comment">
					  </ckeditor>
					</div> 
				</div>
			</div>
		
			<div class="row mt-4">   
				<div class="col s12">
					<button class="m-t-15 pull-left" 
							mat-flat-button color="primary"              
							[disabled]="!form.valid || this.isSaving()"
							(click)="tryMarkForRevision()">
						{{ 'requirementReview.submit' | translate }}
						<mat-icon>send</mat-icon>
					</button>				
		
					<div class="pull-left" *ngIf="this.isSaving()">
						<mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
					</div>  	                   
				</div>			
				<div class="col s12" [hidden]="serverError==''">
					<div class="server-error h4" >{{this.serverError}}</div>    				        			
				</div>							
			</div>	
		</form>	  	

	</div>
</div>


